import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    gridContainer: {
        backgroundColor: 'transparent',
        marginTop: 30,
    },
    paper: {
        height: 126,
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 15,
      
        "@media (max-width: 350px)": {
             overflowY: "scroll",
          },
        
        // "@media screen and (min-device-width: 1380px) and (max-device-width: 1550px)" : { 
        //     paddingLeft: 7
        // },
        // "@media screen and (min-device-width: 1280px) and (max-device-width: 1380px)" : { 
        //     paddingLeft: 4,
        // },
        "@media (max-width: 800px)": {
            paddingLeft: 4,
          },
        border: '1px solid #D4DDE4',
        borderRadius: 8
    },
    cardBorder: {
        border: '1px solid #824ED2',
    },

    image: {
        width: 60 ,
        height: 60,
        marginRight: 13,
        // "@media screen and (min-device-width: 1380px) and (max-device-width: 1550px)" : { 
        //     width: 40 ,
        //     height: 40,
        //     marginRight: 7
        // },
        // "@media screen and (min-device-width: 1280px) and (max-device-width: 1380px)" : { 
        //     width: 30 ,
        //     height: 30,
        //     marginRight: 7
        // },
        "@media screen and (min-device-width: 960px) and (max-device-width: 1025px)" : { 
            width: 40 ,
            height: 40,
            marginRight: 7
        },
        "@media screen and (min-device-width: 600px) and (max-device-width: 758px)" : { 
            width: 40 ,
            height: 40,
            marginRight: 7
        },
        "@media (max-width: 450px)": {
            width: 40 ,
            height: 30,
        },
    },
    cardBody: {
        width: '100%',
        paddingRight: 15
    },
    cardHead: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    cardHeadText: {
        margin: 0,
        color: '#091E42',
        fontSize: 20,
        // "@media screen and (min-device-width: 1380px) and (max-device-width: 1550px)" : { 
        //     fontSize: 16
        // },
        // "@media screen and (min-device-width: 1280px) and (max-device-width: 1380px)" : { 
        //     fontSize: 13
        // },
        "@media screen and (min-device-width: 960px) and (max-device-width: 1025px)" : { 
            fontSize: 16
        },
        "@media screen and (min-device-width: 600px) and (max-device-width: 692px)" : { 
            fontSize: 15
        },
        fontWeight: '600'
    },
    cardText: {
        margin: 0,
        color: '#5B6773',
        fontSize: 14,
        // "@media screen and (min-device-width: 1380px) and (max-device-width: 1550px)" : { 
        //     fontSize: 12        
        // },
        // "@media screen and (min-device-width: 1280px) and (max-device-width: 1380px)" : { 
        //     fontSize: 10
        // },
        // "@media screen and (min-device-width: 1280px) and (max-device-width: 1350px)" : { 
        //     fontSize: 12
        // },
        fontWeight: '400',
    },
    line: {
        margin: 0,
        color: '#C4C4C4',
        fontSize:30,
        marginTop: -5,
        marginLeft: 10,
        marginRight: 10

    },
    select: {
        margin: -4,
        minWidth: 'auto',
        padding: 0,
        height: 30,
        fontSize: 16,
        "@media (max-width: 1550px)": {
            fontSize: 12
          },
    },
    focusSelect: {
        '&:focus': {
            backgroundColor: 'transparent'
        }
    },
    cardBtn: {
        background: 'rgba(130, 78, 210, 0.16)',
        color: '#824ED2',
        fontWeight: '400',
        borderRadius: 26, 
        fontSize: 8,
        height: 24, 
        paddingLeft: 8, 
        paddingRight: 8,
        "@media (min-width: 1770px)": {
        height: 30, 
        paddingLeft: '14px', 
        paddingRight: '14px',   
        fontSize: 12,      
         },      
        textTransform: 'none',
        border: '1px solid rgba(130, 78, 210, 0.16)'

    },
    cardBtnTwo: {
        height: 26,
        border: '1px solid #CFA639 ',
        color: '#fff',
        background: '#CFA639',
        borderRadius: '26px',
        textTransform: 'none'
    }

}));